import React from 'react'

import { useTheme } from '../../contexts/ThemeContext'

import Styled from './Skeleton.styled'

/**
 * Skeleton component
 * @param {'wave'|'pulse'} animation
 * @param {string} className
 * @param {string} fill
 * @param {number|string} height
 * @param {string} tagName
 * @param {'circular'|'rectangular'|'text'} variant
 * @param {number|string} width
 * @param {*} rest
 */
const Skeleton = ({
  animation,
  className,
  fill,
  height,
  tagName,
  variant,
  width,
  ...rest
}) => {
  const { theme } = useTheme()
  return (
    <Styled
      $currentTheme={theme}
      className={className}
      as={tagName}
      $skeletonAnimation={animation}
      $skeletonHeight={height}
      $skeletonVariant={variant}
      $skeletonWidth={width}
      $skeletonFill={fill}
      {...rest}
    />
  )
}

Skeleton.defaultProps = {
  animation: 'pulse',
  variant: 'text',
}

export default Skeleton
